import { ArsContextState, ArsDataState } from "../interface";

/**
 * Extracts mutable ARS data from context state, excluding undo/redo metadata.
 *
 * @param state - The full ARS context state
 * @returns Data-only state used for patch generation
 */
export const extractDataState = <T>(state: ArsContextState<T>): ArsDataState<T> => ({
  analyses: state.analyses,
  analysisMethods: state.analysisMethods,
  analysisSets: state.analysisSets,
  caseWhenConditions: state.caseWhenConditions,
  changed: state.changed,
  comparators: state.comparators,
  dataSubsets: state.dataSubsets,
  datasetsInUse: state.datasetsInUse,
  disableAnalysisMethodEdit: state.disableAnalysisMethodEdit,
  editorDefns: state.editorDefns,
  groupingFactors: state.groupingFactors,
  uiRequestStatus: state.uiRequestStatus,
  variables: state.variables,
  variablesInUse: state.variablesInUse,
});
